import { render, staticRenderFns } from "./StoreOrderDetail.vue?vue&type=template&id=01329d57&"
import script from "./StoreOrderDetail.vue?vue&type=script&lang=js&"
export * from "./StoreOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./StoreOrderDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports